import * as go from 'gojs';
import { getHybridCrusherCRImage } from 'unitData/Crushers/HybridCrusherCR/getImageHybridCrusherCR';
import { getImageBinding, getIOPort, makeNode } from '../../utils';

const HybridCrusherCRTemplate = makeNode(
  getImageBinding('', getHybridCrusherCRImage),
  [getIOPort(go.Spot.Bottom, 'output'), getIOPort(go.Spot.Top, 'input')],
);

export default HybridCrusherCRTemplate;
